import { connect } from "react-redux";
import { useLayout } from "../../../../../../provider/LayoutProvider";
import Filter from "./components/Filter";
import { FiltersContainer } from "./styles";
import { OptionLabel } from "./components/Filter/styles";
import { useState } from "react";

interface ComponentProps {
  statics;
  staticsStates;
}

interface StateFilter {
  text: string;
  spanish: string;
}

const Component = ({ statics, staticsStates }: ComponentProps) => {
  const { resetFilters } = useLayout();
  const [applyFilters, setApplyFilters] = useState<StateFilter[]>([]);
  const [allFiltersCleared, setAllFiltersCleared] = useState<boolean>(false); 

  const setFilter = (filter: StateFilter): void => {
    const existingIndex = applyFilters.findIndex(item => item === filter);
    if (existingIndex === -1) {
      setApplyFilters([...applyFilters, filter]);
    } else {
      const updateFilters = applyFilters.filter((_, index) => index !== existingIndex);
      setApplyFilters(updateFilters);
    }
    if(allFiltersCleared) {
      setAllFiltersCleared(false);
    }
  }

  const clearAllFilters = (): void => {
    setApplyFilters([]);
    setAllFiltersCleared(true);
    resetFilters();
  };

  return (
    <FiltersContainer>
      {statics?.state?.map((filter: StateFilter) => {
        const filterName = "state";
        const fieldName = filterName;
        const value = filter.text;
        const label = filter.spanish;
        return <Filter onClick={() => setFilter(filter)} name={fieldName} value={value} label={label} key={filter.text} cleared={allFiltersCleared}/>;
      })}
      {
        applyFilters.length > 0 ? <OptionLabel onClick={clearAllFilters}> Quitar Filtros </OptionLabel> : null
      }
      
    </FiltersContainer>
  );
};

const state = ({ staticsStore }) => {
  const { data: statics, states: staticsStates } = staticsStore;

  return {
    statics,
    staticsStates,
  };
};

export default connect(state)(Component);
